import * as React from "react";

type NonPaginatedTableProps = {
  cols: TableProps["cols"];
  data: TableProps["data"];
  actions: TableProps["actions"];
  tableProps?: Pick<TableProps, "tableCaption" | "classNames">;
  showErrorComponent: boolean;
  errorMessage: string;
  emptyStateMessage: string;
};
import EmptyState from "../EmptyState/index";
import Table from "./index";
import { TableProps } from "../types";
import styles from "./index.module.css";

function NonPaginatedTable(props: NonPaginatedTableProps) {
  return (
    <>
      {props.data?.length > 0 ? (
        <>
          <div className={styles.tableContainer}>
            <Table
              cols={props.cols}
              data={props.data}
              actions={props.actions}
              {...props.tableProps}
            />
          </div>
        </>
      ) : (
        <>
          <>
            {props.showErrorComponent ? (
              <EmptyState variant="error" title={props.errorMessage} />
            ) : null}
            {!props.showErrorComponent ? (
              <EmptyState title={props.emptyStateMessage} />
            ) : null}
          </>
        </>
      )}
    </>
  );
}

export default NonPaginatedTable;
